/** Window event name: Main.jsx listens and refetches ticket domains/types for the sidebar. */
export const TICKET_MENU_RELOAD_EVENT = "apit-reload-ticket-menu";

/** Sidebar chat list listens and patches group/channel avatar uploads after upload in chat settings. */
export const CHAT_AVATAR_UPDATED_EVENT = "apit-chat-avatar-updated";

export function requestTicketMenuReload() {
	if (typeof window === "undefined") return;
	window.dispatchEvent(new CustomEvent(TICKET_MENU_RELOAD_EVENT));
}
